import React from "react";
import styled from "styled-components";

import { useUserPermissions } from "../../hooks/useUserPermissions";
import { HelpTooltip } from "../HelpTooltip";

const TOOLTIP_TITLE =
  "Your management company has restricted access to this feature. To make any updates, kindly reach out to your regional supervisor.";

const StyledChildrenWrapper = styled.span`
  * {
    pointer-events: none !important;
  }
`;

export const ReadOnlyWrapper: React.FC = (props) => {
  const { readOnly } = useUserPermissions();

  return (
    <>
      {readOnly && (
        <HelpTooltip customXs={12} withIcon={false} text={TOOLTIP_TITLE}>
          <StyledChildrenWrapper>
            {React.Children.map(
              props.children,
              (cmp) =>
                cmp &&
                React.cloneElement(cmp as React.ReactElement, {
                  // Overwrite any control handler
                  onClick: undefined,
                  disabled: true,
                  isDisabled: true,
                  onChange: undefined,
                })
            )}
          </StyledChildrenWrapper>
        </HelpTooltip>
      )}
      {!readOnly && props.children}
    </>
  );
};
